import { useNavigate } from 'react-router-dom'
import { PhoneMissed, MessageCircle, AtSign, ListChecks, PenLine, Mail } from 'lucide-react'
import { KpiCard } from '../../patterns/KpiCard'
import { useAppShellStore } from '../../../stores/appShellStore'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function HomeKpis({ kpis, onMentionsClick }: { kpis: any; onMentionsClick: () => void }) {
  const navigate = useNavigate()
  // Bare /channels/@me renders the Chat shell only when section==='chats'
  // (PrimarySidebar handleChats does the same switch before navigating).
  const goChat = (to: string) => { useAppShellStore.getState().setSection('chats'); navigate(to) }
  if (!kpis) return null
  const cards: Array<{ key: string; label: string; value: number; icon: React.ReactNode; accent?: string; hint?: React.ReactNode; onClick: () => void } | null> = [
    { key: 'calls', label: 'Missed calls', value: kpis.missedCallsToday, icon: <PhoneMissed size={18} />, accent: kpis.missedCallsToday ? 'text-rose-400' : undefined, hint: 'today', onClick: () => navigate('/dashboards/callhistory') },
    { key: 'dms', label: 'Unread DMs', value: kpis.unreadDmMessages, icon: <MessageCircle size={18} />, hint: `${kpis.unreadDmChats} chats`, onClick: () => goChat('/channels/@me') },
    { key: 'mentions', label: 'Mentions', value: kpis.unreadMentions, icon: <AtSign size={18} />, hint: 'unread', onClick: onMentionsClick },
    { key: 'due', label: 'Due today', value: kpis.tasksDueToday, icon: <ListChecks size={18} />, hint: kpis.tasksOverdue ? <span className="text-rose-400">{kpis.tasksOverdue} overdue</span> : 'tasks', onClick: () => navigate('/workspace/tasks') },
    { key: 'sign', label: 'Signatures', value: kpis.signaturesPending, icon: <PenLine size={18} />, hint: 'waiting', onClick: () => navigate('/workspace/sign') },
    kpis.mailUnread == null ? null : { key: 'mail', label: 'Mail', value: kpis.mailUnread, icon: <Mail size={18} />, hint: 'inbound 7d', onClick: () => navigate('/workspace/mail') },
  ]
  const visible = cards.filter(Boolean) as NonNullable<(typeof cards)[number]>[]
  const colClass = ({ 4: 'xl:grid-cols-4', 5: 'xl:grid-cols-5', 6: 'xl:grid-cols-6' } as Record<number, string>)[Math.min(visible.length, 6)] ?? 'xl:grid-cols-6'
  return (
    <div className={`grid grid-cols-2 gap-4 md:grid-cols-3 ${colClass}`}>
      {visible.map((c) => (
        <button key={c.key} type="button" onClick={c.onClick} className="text-left">
          <KpiCard label={c.label} value={c.value} icon={c.icon} accent={c.accent} hint={c.hint} className="h-full transition hover:ring-border" />
        </button>
      ))}
    </div>
  )
}
